/* eslint-disable react/jsx-pascal-case */
import React from "react";
import { toInteger, toUpper } from "lodash";
import * as CONFIG from "../../redux_store/configState";
import { LOAD_WIND_DATA, updateDesigner, SHOW_LOADING_BACKDROP } from "../../redux_store/appState";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector, useDispatch } from "react-redux";
import { Palette, API_BASE, MANUFACTURER } from "../../AppConfig";
import TemplateCard from "../TemplateCard";
import Paper from "@material-ui/core/Paper";
import Tooltip from "@material-ui/core/Tooltip";
import BSL_Button from "../../components/BSL_Button";
import BSL_CheckBox from "../../components/BSL_CheckBox";
import BSL_TextInput from "../../components/BSL_TextInput";
import { JsonView, darkStyles } from "react-json-view-lite";
import LinearProgress from "@material-ui/core/LinearProgress";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import SegmentedButtonGroup from "../../components/SegmentedButtonGroup";
import BSL_Select, { BSL_FilterSelect } from "../../components/BSL_Select";
import _cloneDeep from "lodash/cloneDeep";
import Message from "../../components/Message";
import BSL_Dialog from "../../components/BSL_Dialog";
import HelpButton from "../../components/BSL_HelpButton";
import AddressAutoComplete from "../../components/AddressAutoComplete";
import { calculate_wind_data, validateFullJob } from "../../redux_store/jobState_Validation";
import FrameAppBar from "../../components_designer/main_drawer/FrameAppBar";
import BSL_StatusChip from "../../components/BSL_StatusChip";
import BSL_ControlContainer from "../../components/BSL_ControlContainer";
import { DStateActive } from "../../redux_store/appStateHelper";
import BusinessOffer from "../BusinessOffer/BusinessOffer";
import { GetStateFromPOA } from "../ManageBusiness/BusinessList";
import { Box, Modal } from "@material-ui/core";
import DecksPage from "../../deck_start/DecksPage";
import { fixedState, useDeckState } from "../../deck_start/DecksState";
import { getRect2Orientation } from "../../deck_start/DrawDeck";
import { getDeckCutout, getDeckHeight, getDeckType, getDeckWidth, updateAttachments } from "./DeckHelper";
import {
    BaseURL,
    setNull,
    checkDoesObjectHaveContent,
    deepCopy,
    toNumber,
    objectByString,
    fetchTimeout,
    mergeDeep,
    checkValidJSON,
} from "../../components/Common";
import {
    SHOW_CUSTOMER_JOB_PANEL,
    resetDesigner,
    updateUserFromWeb,
    toggleDesigner,
    updateAPP,
} from "../../redux_store/appState";
import {
    changeMainPage,
    changePage,
    DESIGNER_PAGE,
    saveUserToWeb,
    SetAppDialogMessage,
    SHOW_DESIGNER_MESSAGE,
} from "../../redux_store/appState";
import {
    newJob,
    newDuplicateJob,
    NEW_JOB,
    newDefaultJobState,
    checkJobStateValidationSchema,
    getWindDataLoading,
} from "../../redux_store/jobState";
import NonStandardDeliveryCheck from "./NonStandardDeliveryCheck";

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme?.brand?.LYSAGHT ? "#f2f2f0" : "white",
    },
    page: {
        marginLeft: "200px",
        marginRight: "80px",
        textAlign: "left",
        display: "flex",
        flexDirection: "row",
    },
    headerLysaght: {
        font: "36px " + Palette?.Lysaght?.FontFamily + ", 'Gibson', SegoeUI-Bold, Segoe UI",
        fontWeight: "700",
        letterSpacing: "1px",
        color: Palette.Lysaght.HeadingLightBlue,
        verticalAlign: "text-top",
        paddingRight: "20px",
        textTransform: "uppercase",
    },
    sectionHeaderLysaght: {
        font: "24px " + Palette?.Lysaght?.FontFamily + ", 'Gibson', SegoeUI-Bold, Segoe UI",
        fontWeight: "600",
        color: Palette.Lysaght.DarkBlue,
        verticalAlign: "text-top",
        width: "180px",
        textTransform: "uppercase",
    },
    header: {
        font: "36px " + Palette?.Fielders?.FontFamily + ", 'Univers45', sans-serif",
        fontWeight: "500",
        letterSpacing: "1px",
        color: theme?.brand?.FIELDERS ? Palette?.Control?.DarkGrey : Palette?.Lysaght?.HeadingLightBlue,
        verticalAlign: "text-top",
        paddingRight: "20px",
    },
    media: {
        // ⚠️ object-fit is not supported by IE 11.
        objectFit: "contain",
        width: "100%",
        height: "400px",
        maxWidth: "800px",
    },
    sectionContainer: {
        font: "18pt " + Palette?.Fielders?.FontFamilySecondary + ", 'Univers45', sans-serif",
        fontWeight: "400",
        color: Palette.Control.DarkGrey,
        verticalAlign: "text-top",
        display: "flex",
        paddingBottom: "20px",
    },
    sectionHeader: {
        font: "24px " + Palette?.Fielders?.FontFamily + ", 'Univers45', sans-serif",
        fontWeight: "400",
        color: theme?.brand?.FIELDERS ? Palette?.Control?.DarkGrey : Palette?.Lysaght?.DarkBlue,
        verticalAlign: "text-top",
        width: "180px",
        paddingTop: "14px",
        whiteSpace: "nowrap",
    },
    sectionContent: {
        font: "18pt " + Palette?.Fielders?.FontFamilySecondary + ", 'Univers45', sans-serif",
        fontWeight: "400",
        color: Palette.Control.DarkGrey,
        verticalAlign: "text-top",
        flex: "1",
        maxWidth: "600px",
        minWidth: "200px",
    },
    sectionSubSection: {
        font: "18pt " + Palette?.Fielders?.FontFamilySecondary + ", 'Univers45', sans-serif",
        fontWeight: "400",
        color: Palette?.Control?.DarkGrey,
        verticalAlign: "text-top",
        flex: "1",
        display: "flex",
    },
    divider: {
        width: "100%",
        maxWidth: "770px",
        borderTop: "1px solid #6B879988",
        marginTop: "12px",
        marginBottom: "24px",
    },
    subHeader: {
        flex: "1",
        font: "14px " + theme.typography.fontFamily,
        fontWeight: theme?.brand?.FIELDERS ? "700" : "200",
        color: Palette?.Control?.DarkGrey,
        padding: "16px 0px 6px 0px",
        display: "flex",
        alignItems: "center",
    },
    windSpeed: {
        backgroundColor: "#ffc8c8",
        padding: "10px",
        textAlign: "center",
        font: "12px " + theme?.typography?.fontFamily,
    },
    errorText: {
        color: "#f44336",
    },
    greenBG: {
        backgroundColor: "#cbf3cb",
        padding: "10px",
        textAlign: "center",
        font: "12px " + theme?.typography?.fontFamily,
    },
    orangeBG: {
        backgroundColor: "#fbdaad",
        padding: "10px",
        textAlign: "center",
        font: "12px " + theme?.typography?.fontFamily,
    },
    smallHeader: {
        color: "rgba(0, 0, 0, 0.54)",
        fontSize: "0.75rem",
        marginTop: "8px",
    },
}));

function debounce(fn, wait) {
    let t;
    return function () {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, arguments), wait);
    };
}

export default function NewJob(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const validationSchema = useSelector((state) => state.config.validationSchema);
    const app = useSelector((state) => state.app);

    const job = useSelector((state) => state.job);
    const offerings = useSelector((state) => state.app.offerings);
    const config = useSelector((state) => state.config);
    const user = app.user;
    const logged_user_id = user.id;
    const [newJobState, setNewJobState] = React.useState(
        props.job ? deepCopy(props.job) : deepCopy(newDefaultJobState(config, "", user))
    );
    const { Distributor, Customer } = newJobState;
    const [loaded, setLoaded] = React.useState(false);
    const [editCustomOffering, setEditCustomOffering] = React.useState(false);
    const [jsonValid, setJSONValid] = React.useState(false);
    const [value, setValue] = React.useState("");
    const [deckPageOpen, setDeckPageOpen] = React.useState(false);
    const [deckState, updateDeckState] = useDeckState(fixedState);
    const businessList = useSelector((state) => state?.app?.DistributorList);
    const [allowSave, setAllowSave] = React.useState(true);
    const [selectedPricingTier, setSelectedPricingTier] = React.useState(
        newJobState?.Customer?.DistLevel ?? newJobState?.Distributor?.DistLevel ?? ""
    );
    const [carportDisabled, setCarportDisabled] = React.useState(true);
    const [carportDisabledMessage, setCarportDisabledMessage] = React.useState("Awaiting wind data");
    const [carportTemplates, setCarportTemplates] = React.useState(
        config?.design_options["National Carport"]?.design_templates || {}
    );
    const [blockingOptionsExist, setBlockingOptionsExist] = React.useState(true);
    const [blockingOptions, setBlockingOptions] = React.useState([
        { Key: 0, Display: "0", disabled: false },
        { Key: 1, Display: "1", disabled: false },
        { Key: 2, Display: "2", disabled: false },
        { Key: 3, Display: "3 / 4", disabled: false },
    ]);
    const [salesContacts, setSalesContacts] = React.useState([]);
    const [selectedSalesContact, setSelectedSalesContact] = React.useState({});
    const [showWindDetails, setShowWindDetails] = React.useState(false);
    const [showMessage, setShowMessage] = React.useState(false);
    const [errorState, setErrorState] = React.useState(
        props.job ? setNull(props.job) : deepCopy(newDefaultJobState(config)).ErrorMap
    );
    const [windDataLoading, setWindDataLoading] = React.useState(false);
    const [closeAfterWindLoaded, setCloseAfterWindLoaded] = React.useState(false);
    const [errorWindDataLoading, setErrorWindDataLoading] = React.useState(false);
    const [design_selected, setDesign_selected] = React.useState(window.LYSAGHT ? "Skillion" : "Flat");
    const [subTypeSelected, setSubTypeSelected] = React.useState(
        job?.AreaSpecifications?.[0]?.SHAPE?.DesignTemplateName || null
    );
    const [openImportanceLevel1Dialog, setOpenImportanceLevel1Dialog] = React.useState(false);
    const [isNonStdDelivery, setIsNonStdDelivery] = React.useState(false);
    const [hasAckNonStdDelivery, setHasAckNonStdDelivery] = React.useState(false);
    const [isLoadingDeliveryArea, setIsLoadingDeliveryArea] = React.useState(false);
    const [newNonStdDelRecord, setNewNonStdDelRecord] = React.useState({});
    const [errorLoadingDeliveryArea, setErrorLoadingDeliveryArea] = React.useState(false);

    const topRef = React.useRef(null);
    const jobNameRef = React.useRef(null);
    const siteAddressRef = React.useRef(null);
    const windDateRef = React.useRef(null);
    const blockingRef = React.useRef(null);
    const hasMounted = React.useRef(false);
    const deliveryAreaRef = React.useRef(null);

    const editMode = props?.mode && props?.mode === "Edit";
    const duplicateMode = props?.mode && props?.mode === "Duplicate";
    const newMode = (props?.mode && props?.mode === "New") || !props?.mode;

    let image_url = API_BASE() + "svg/" + newJobState.id + "/layout.svg";
    let brand = window.LYSAGHT ? "Lysaght" : "Fielders Centenary";
    let businessesSorted = [];

    const account_tiers = React.useMemo(() => {
        const tiers = [];

        const lyves = Distributor?.LYVESAccount ?? "";
        if (lyves) {
            tiers.push({ value: lyves, label: `${lyves} (Account Default)` });
        }

        const dStateActive = DStateActive({ config });

        const pricingAccounts = config?.region?.pricing_accounts;
        if (pricingAccounts) {
            for (const price_type of Object.keys(pricingAccounts)) {
                if (price_type === "DMAPSTORE") continue;

                tiers.push({ label: `${price_type} ACCOUNTS`, isDisabled: true });

                for (const account of pricingAccounts[price_type] ?? []) {
                    const customerName = account["CUSTOMER NAME 1"];
                    const d365Code = account.D365_CODE;
                    const custCode = account["CUST CODE"];

                    let activeCode = custCode;

                    if (dStateActive) {
                        if (d365Code) activeCode = d365Code;

                        const store = pricingAccounts.DMAPSTORE?.find((v) => v["CUST CODE"] === custCode);
                        if (store?.D365_CODE) activeCode = store.D365_CODE;
                    }

                    tiers.push({
                        value: activeCode,
                        label: (
                            <p style={{ margin: 0 }}>
                                {customerName ? `${customerName} ` : ""}
                                <span style={{ fontWeight: 800 }}>{activeCode}</span>
                            </p>
                        ),
                    });
                }
            }
        }

        return tiers;
    }, [config, Distributor?.LYVESAccount]);

    React.useEffect(() => {
        if (!hasMounted.current) {
            hasMounted.current = true;
            return; // Skip on initial render
        }

        if (!Distributor?.Code) return;

        const fetchSalesContacts = async () => {
            try {
                let url = API_BASE() + "users/" + Distributor?.Code;
                const response = await fetchTimeout(url, {
                    method: "GET",
                });

                if (!response.ok) {
                    throw new Error();
                }

                const json = await response.json();

                const filteredContacts = json.map((contact) => {
                    const { id, Email, FirstName, LastName, Phone } = contact;
                    const DisplayName = `${FirstName} ${LastName}`.trim();
                    return { id, Email, FirstName, LastName, DisplayName, Phone };
                });

                setSalesContacts(filteredContacts);
            } catch (e) {
                setSalesContacts([]);
            }
        };

        fetchSalesContacts();

        if (customer_types) {
            handleStateUpdate("Customer", "Type", Distributor?.MarkupStructure?.MarkupDefault ?? customer_types[0].Key);
        }
    }, [Distributor?.Code]);

    React.useEffect(() => {
        let tierValue = newJobState?.Customer?.DistLevel || newJobState?.Distributor?.DistLevel || "";

        if (
            tierValue === "Retail" ||
            tierValue === "Trade" ||
            tierValue.includes("Dist") ||
            tierValue.includes("Cost")
        ) {
            tierValue = newJobState?.Distributor.LYVESAccount;
        }

        const match = account_tiers.find((t) => t.value === tierValue);

        if (match) setSelectedPricingTier(match);
    }, [
        newJobState?.Customer?.DistLevel,
        newJobState?.Distributor?.DistLevel,
        newJobState?.Distributor?.Code,
        newJobState?.Distributor.LYVESAccount,
        account_tiers,
    ]);

    React.useEffect(() => {
        if (newJobState?.User) {
            const { id, Email, FirstName, LastName, Phone } = newJobState.User;
            const DisplayName = `${FirstName} ${LastName}`.trim();
            const newContact = { id, Email, FirstName, LastName, DisplayName, Phone };

            setSelectedSalesContact(newContact);

            const isExistingContact = salesContacts.some((contact) => contact.id === newContact.id);

            if (!isExistingContact) {
                setSalesContacts((prevContacts) => [...prevContacts, newContact]);
            }
        }
    }, [newJobState?.User?.id, salesContacts]);

    React.useEffect(() => {
        if (newJobState?.SiteParameters?.WindData?.WindZoneAS1170) {
            let newState = { ...newJobState };
            newState.SiteParameters.WindData.WindZoneAS1170.calculated = calculate_wind_data(
                newState.SiteParameters.WindData.WindZoneAS1170,
                newState?.DesignParameters?.vr_mode,
                config?.job_settings?.round_down_wz
            );
            setNewJobState(newState);
        }
    }, [newJobState?.DesignParameters?.vr_mode]);

    React.useEffect(() => {
        if (!loaded) {
            window.scrollTo(0, 0);

            //load businesses
            let api_url = API_BASE() + "business";
            fetchTimeout(api_url, {
                method: "GET",
            })
                .then((response) => response.json())
                .then((json) => {
                    dispatch(updateAPP("DistributorList", json));
                })
                .catch((e) => {});
            setLoaded(true);
        }
    });

    const siteAddressLatLng = React.useMemo(() => {
        if (
            newJobState?.SiteParameters?.Address?.LatLng &&
            newJobState?.SiteParameters?.Address?.LatLng.lat !== 0 &&
            newJobState?.SiteParameters?.Address?.LatLng.lng !== 0
        ) {
            return newJobState.SiteParameters.Address.LatLng;
        }

        const windLatLng = newJobState?.SiteParameters?.WindData?.WindZoneAS1170?.latlng;
        if (windLatLng) {
            const [lat, lng] = windLatLng.split(",").map((item) => parseFloat(item));
            setNewJobState((prevState) => {
                const newState = {
                    ...prevState,
                    SiteParameters: {
                        ...prevState.SiteParameters,
                        Address: {
                            ...prevState.SiteParameters.Address,
                            LatLng: { lat, lng },
                        },
                    },
                };
                return newState;
            });
            return { lat, lng };
        }

        return null;
    }, [newJobState?.SiteParameters?.Address?.LatLng, newJobState?.WindData?.WindZoneAS1170?.latlng]);

    const [latLang, setLatLang] = React.useState(siteAddressLatLng);

    React.useEffect(() => {
        // updating latlang only if its changed from previous state
        // this is to handle unnecessary calls to the useEffect dependant on siteAddressLatLng
        if (!latLang || latLang.lat !== siteAddressLatLng?.lat || latLang.lng !== siteAddressLatLng?.lng) {
            setNewJobState((prevState) => {
                const newState = {
                    ...prevState,
                    SiteParameters: {
                        ...prevState.SiteParameters,
                        Address: {
                            ...prevState.SiteParameters.Address,
                            LatLng: latLang,
                        },
                    },
                };
                return newState;
            });
        }
    }, [latLang]);

    const abortControllerRef = React.useRef(null);
    const siteAddressLatLngRef = React.useRef(siteAddressLatLng);

    React.useEffect(() => {
        if (!siteAddressLatLng) return;
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }

        const abortController = new AbortController();
        abortControllerRef.current = abortController;

        const latLngString =
            newJobState?.SiteParameters &&
            newJobState?.SiteParameters.Address &&
            newJobState?.SiteParameters.Address.LatLng
                ? `${newJobState?.SiteParameters.Address.LatLng.lat.toFixed(
                      7
                  )},${newJobState?.SiteParameters.Address.LatLng.lng.toFixed(7)}`
                : ""; // Default value if any of the properties are undefined

        const hasLatLngChanged =
            !siteAddressLatLngRef.current ||
            siteAddressLatLng.lat !== siteAddressLatLngRef.current.lat ||
            siteAddressLatLng.lng !== siteAddressLatLngRef.current.lng;
        if (!hasLatLngChanged) {
            return;
        }

        if (
            newJobState?.SiteParameters?.WindData?.WindZoneAS1170?.critical &&
            newJobState?.SiteParameters?.WindData?.WindZoneAS1170?.latlng !== latLngString
        ) {
            updateWind();
        }

        getWindDataLoading({
            newJobState,
            setWindDataLoading,
            dispatch,
            setErrorWindDataLoading,
            abortSignal: abortController.signal,
        });
        siteAddressLatLngRef.current = siteAddressLatLng;

        return () => {};
    }, [siteAddressLatLng]);

    React.useEffect(() => {
        // Temporarily disabled
        return;
        if (isNonStdDelivery) {
            const timestamp = Date.now();
            const postCode = String(newJobState?.SiteParameters?.Address?.PostCode ?? "0000");
            const state = newJobState?.SiteParameters?.Address?.State ?? "";
            const town = newJobState?.SiteParameters?.Address?.Suburb ?? "";
            const ackAt = hasAckNonStdDelivery ? timestamp : null;
            const areaId = [town, state, postCode].filter(Boolean).join("").toLowerCase().replace(/\s+/g, "");

            const newAreaHistory = {
                Id: areaId,
                PostCode: postCode,
                State: state,
                Town: town,
                AcknowledgedAt: ackAt,
                User: app?.user?.id || "unknown",
            };

            setNewNonStdDelRecord(newAreaHistory);
        } else {
            setNewNonStdDelRecord({});
        }
    }, [
        isNonStdDelivery,
        hasAckNonStdDelivery,
        newJobState?.SiteParameters?.Address?.PostCode,
        newJobState?.SiteParameters?.Address?.State,
        newJobState?.SiteParameters?.Address?.Suburb,
        app?.user?.id,
    ]);

    React.useEffect(() => {
        if (
            newJobState?.SiteParameters?.WindData?.WindZoneAS1170?.region === "D" &&
            newJobState?.DesignParameters?.vr_mode !== 1000 &&
            newJobState?.SiteParameters?.Address?.FormattedAddress !== job?.SiteParameters?.Address?.FormattedAddress
        ) {
            let newState = { ...newJobState };
            newState.DesignParameters = {
                ...newState.DesignParameters,
                vr_mode: 1000,
            };
            setNewJobState(newState);
        }
    }, [newJobState?.SiteParameters?.WindData?.WindZoneAS1170]);

    React.useEffect(() => {
        getCarportTemplates();
        getCarportDisabledMessage();
        validateBlockingOptions();

        let allowSave = true;

        if (newJobState?.DesignSummary && newJobState?.DesignSummary === "National Carport") {
            if (windDataLoading) {
                allowSave = false;
            }

            if (
                newJobState?.SiteParameters?.WindData?.WindZoneAS1170?.region &&
                newJobState?.SiteParameters?.WindData?.WindZoneAS1170?.region === "C"
            ) {
                const carportType = newJobState?.AreaSpecifications[0]?.SHAPE?.DesignTemplateName || "";

                if (carportType.includes("Non-Cyclonic")) {
                    allowSave = false;
                    const errorMessage = "a non-cyclonic carport cannot be built in a cyclonic region";
                    let newErrorState = { ...errorState };

                    if (newErrorState?.SiteParameters?.Address?.FormattedAddress) {
                        newErrorState.SiteParameters.Address.FormattedAddress = errorMessage;
                    } else {
                        newErrorState.SiteParameters.Address = {
                            FormattedAddress: errorMessage,
                        };
                    }

                    setErrorState(newErrorState);

                    dispatch({
                        type: SHOW_DESIGNER_MESSAGE,
                        message: {
                            message: "Error: " + errorMessage,
                            type: "error",
                        },
                    });
                }
            }
        }

        setAllowSave(allowSave);
    }, [
        windDataLoading,
        design_selected,
        subTypeSelected,
        newJobState?.SiteParameters?.ImportanceLevel,
        newJobState?.SiteParameters?.WindData?.WindZone,
        newJobState?.SiteParameters.WindData.Blocking,
    ]);

    const APP_LOAD_WIND_DATA = app?.designer?.[LOAD_WIND_DATA];
    const APP_SHOW_CUSTOMER_JOB_PANEL = app?.designer?.[SHOW_CUSTOMER_JOB_PANEL];

    React.useEffect(() => {
        if (APP_LOAD_WIND_DATA && !APP_SHOW_CUSTOMER_JOB_PANEL) {
            if (closeAfterWindLoaded) {
                setCloseAfterWindLoaded(false);
                dispatch(updateDesigner(SHOW_LOADING_BACKDROP, false));
                dispatch(updateDesigner(LOAD_WIND_DATA, false));
            }
            if (windDataLoading && !closeAfterWindLoaded) {
                setCloseAfterWindLoaded(true);
            }
        }
    }, [windDataLoading]);

    React.useEffect(() => {
        validateBlockingSelection();
    }, [blockingOptions, newJobState?.SiteParameters?.WindData?.Blocking]);

    let dealers = [];
    const business = app?.user?.BusinessDetails;
    if (business) {
        dealers.push({ Display: business.Name, Key: business.Code });
        if (business.Children) {
            for (let child of business.Children) {
                dealers.push({ Display: child.Name, Key: child.Code });
            }
        }
    }

    // Update user Offer to align with updated linked business
    BusinessOffer({ user, Distributor, dispatch, saveUserToWeb });

    const [LinkedBusiness, setLinkedBusiness] = React.useState(() => {
        let initialBusinesses = [];

        // If user and user.BusinessDetails exist
        if (user && user.BusinessDetails && user.BusinessDetails.Offer && user.BusinessDetails.Offer.LinkedBusiness) {
            initialBusinesses.push(...user.BusinessDetails.Offer.LinkedBusiness);
            initialBusinesses.push({
                value: user.BusinessDetails.Code,
                label: user.BusinessDetails.Name,
                state: GetStateFromPOA({ offerings, poa: user.BusinessDetails?.Offer?.Regions?.[0] }),
            });
            if (job)
                // Add current job business
                initialBusinesses.push({
                    value: job.Distributor.Code,
                    label: job.Distributor.Name,
                    state: GetStateFromPOA({ offerings, poa: job.Distributor?.Offer?.Regions?.[0] }),
                });
        }

        // If Distributor and Distributor.Code exist
        if (Distributor && Distributor.Code) {
            const defaultBusiness = {
                value: Distributor.Code,
                label: Distributor.Name,
                state: GetStateFromPOA({ offerings, poa: user.BusinessDetails?.Offer?.Regions?.[0] }),
            };
            if (!initialBusinesses.includes(defaultBusiness)) initialBusinesses.push();
        }

        const uniqueValues = new Set();
        // Filter out objects with duplicate "value" property
        const uniqueBusinesses = initialBusinesses.filter((obj) => {
            // If the value is already in the Set, return false to filter it out
            if (uniqueValues.has(obj.value)) {
                return false;
            }
            // Otherwise, add the value to the Set and return true to keep the object
            uniqueValues.add(obj.value);
            return true;
        });

        // Convert the array to a Set to remove duplicates and then back to an array
        return uniqueBusinesses;
    });

    if (editMode || toNumber(user?.Role) < 90 || !businessList) {
        if (LinkedBusiness.length > 0)
            LinkedBusiness.map((business) =>
                businessesSorted.push({
                    Display: business.label + " - " + business.state,
                    Key: business.value,
                    State: business.state,
                })
            );
        else
            businessesSorted.push({
                Display: Distributor.Name,
                Key: Distributor.Code,
                State: GetStateFromPOA({ offerings, poa: Distributor?.Offer?.Regions?.[0] }),
            });
    } else {
        businessesSorted.push({
            disabled: true,
            Key: "[BBC]",
            Display: "[BBC Licenses]",
            type: "BBC",
        });

        if (businessList && businessList.length > 0)
            for (var item of businessList) {
                if (item.Status !== "ARCHIVED" && item.Type === "BBC")
                    businessesSorted.push({
                        Key: item.id,
                        Display: item.id + "-" + item.Name,
                        type: "BBC",
                        State: GetStateFromPOA({ offerings, poa: item?.Offer?.Regions?.[0] }),
                    });
            }

        businessesSorted.push({
            disabled: true,
            Key: "[Engineers]",
            Display: "[Engineers Licenses]",
            type: "Engineer",
        });

        if (businessList && businessList.length > 0)
            for (var item of businessList) {
                if (item.Status !== "ARCHIVED" && item.Type === "Engineer")
                    businessesSorted.push({
                        Key: item.id,
                        Display: item.id + "-" + item.Name,
                        type: "Engineer",
                        State: GetStateFromPOA({ offerings, poa: item?.Offer?.Regions?.[0] }),
                    });
            }

        businessesSorted.push({
            disabled: true,
            Key: "[Customers]",
            Display: "[Customers Licenses]",
            type: "Customer",
        });

        if (businessList && businessList.length > 0)
            for (var item of businessList) {
                if (item.Status !== "ARCHIVED" && (!item.Type || (item.Type !== "Engineer" && item.Type !== "BBC")))
                    businessesSorted.push({
                        Key: item.id,
                        Display: item.id + "-" + item.Name,
                        type: "Customer",
                        State: GetStateFromPOA({ offerings, poa: item?.Offer?.Regions?.[0] }),
                    });
            }
    }

    var index = dealers
        .map((x) => {
            return x.Key;
        })
        .indexOf(Distributor.Code);
    if (index < 0) dealers.push({ Display: Distributor.Name, Key: Distributor.Code });

    let customer_types = [];
    if (Distributor?.MarkupStructure?.Markups)
        for (let key in Distributor.MarkupStructure.Markups) {
            let item = Distributor.MarkupStructure.Markups[key];
            customer_types.push({
                Key: key,
                Display: item?.DisplayName ? item.DisplayName : key,
            });
        }

    let handleStateUpdate = (section, parameter, e = null, value = null) => {
        let newState = { ...newJobState };
        let newErrorState = { ...errorState };

        if (value === null) value = e;
        if (value?.target?.value) value = e?.target?.value;

        let subsection = null;
        if (parameter && parameter.includes(".")) {
            let parameter_split = parameter.split(".");
            subsection = parameter_split[0];
            parameter = parameter_split[1];
        } else if (section && section.includes(".")) {
            let section_split = section.split(".");
            section = section_split[0];
            subsection = section_split[1];
        }

        if (["FirstName", "LastName"].includes(parameter)) {
            let old_suggested_name = newJobState.Customer.FirstName + " " + newJobState.Customer.LastName;
            let new_suggested_name = old_suggested_name;
            if (parameter === "FirstName") {
                new_suggested_name = value + " " + newJobState.Customer.LastName;
            }
            if (parameter === "LastName") {
                new_suggested_name = newJobState.Customer.FirstName + " " + value;
            }
            if (newState.Customer.JobName.includes(old_suggested_name) || !newState.Customer.JobName) {
                if (newState.Customer.JobName.includes(old_suggested_name))
                    new_suggested_name = newState.Customer.JobName.replace(old_suggested_name, new_suggested_name);
                newState.Customer.JobName = new_suggested_name;
                let error = checkJobStateValidationSchema(
                    validationSchema,
                    "Customer",
                    null,
                    "JobName",
                    newState.Customer.JobName
                );
                newErrorState["Customer"]["JobName"] = error;
            }
        }

        let error = checkJobStateValidationSchema(validationSchema, section, subsection, parameter, value);

        if (
            ((section === "Customer" && newState.SiteParameters.AddressSameAsMailingAddress) ||
                section === "SiteParameters") &&
            parameter === "Address"
        ) {
            newState[section][parameter] = value;

            let newErrorState = { ...errorState };
            let address = value;

            if (address?.FormattedAddress !== undefined) address = address?.FormattedAddress;

            let siteAddressError = checkJobStateValidationSchema(
                validationSchema,
                "SiteParameters",
                "Address",
                "FormattedAddress",
                address
            );

            if (!newErrorState?.SiteParameters?.Address?.FormattedAddress) {
                newErrorState.SiteParameters.Address = {
                    FormattedAddress: siteAddressError,
                };
            } else newErrorState.SiteParameters.Address.FormattedAddress = siteAddressError;
        }
        if (subsection) {
            newState[section][subsection][parameter] = value;
            newErrorState[section][subsection][parameter] = error;
        } else if (parameter) {
            newState[section][parameter] = value;
            newErrorState[section][parameter] = error;
        } else {
            newState[section] = value;
            newErrorState[section] = error;
        }

        setNewJobState(newState);
        setErrorState(newErrorState);
    };

    const getCarportTemplates = () => {
        const templates = deepCopy(config?.design_options["National Carport"]?.design_templates || {});
        const windRegion = newJobState?.SiteParameters?.WindData?.WindZoneAS1170?.region || "";
        const isCyclonic = windRegion === "C" || windRegion === "D";

        let filteredTemplates = templates;

        if (isCyclonic) {
            filteredTemplates = Object.keys(templates)
                .filter((key) => !key.toLowerCase().includes("non-cyclonic"))
                .reduce((obj, key) => {
                    obj[key] = templates[key];
                    return obj;
                }, {});
        }

        setCarportTemplates(filteredTemplates);
    };

    const getCarportDisabledMessage = () => {
        let disabled = true;
        let disabledMessage = null;

        if (Object.keys(carportTemplates).length === 0) {
            disabledMessage = "Unavailable at this location";
        } else if (windDataLoading) {
            disabledMessage = "Awaiting wind data";
        } else if (!newJobState?.SiteParameters?.WindData?.WindZoneAS1170) {
            disabledMessage = "Requires wind data";
        } else {
            disabled = false;
        }

        setCarportDisabled(disabled);
        setCarportDisabledMessage(disabledMessage);
    };

    const getLouvreDisabledMessage = () => {
        if (windDataLoading) {
            return "Awaiting wind data";
        } else if (!newJobState?.SiteParameters?.WindData?.WindZoneAS1170) {
            return "Requires wind data";
        } else {
            const importance_level = newJobState?.SiteParameters?.ImportanceLevel || 2;
            let wz = newJobState?.SiteParameters?.WindData?.WindZone;
            if (importance_level === 1) {
                wz =
                    newJobState?.SiteParameters?.WindData?.WindZoneAS1170?.calculated?.importance_level_1
                        ?.windzone_equiv;
            }
            if (importance_level === 2) {
                wz =
                    newJobState?.SiteParameters?.WindData?.WindZoneAS1170?.calculated?.importance_level_2
                        ?.windzone_equiv;
            }
            if (importance_level === 3) {
                wz =
                    newJobState?.SiteParameters?.WindData?.WindZoneAS1170?.calculated?.importance_level_3
                        ?.windzone_equiv;
            }

            if (wz !== "N1" && wz !== "N2" && wz !== "N3") {
                return "Only available in N1-N3";
            } else {
            }
        }
    };

    const validateBlockingOptions = () => {
        let blocking = [
            { Key: 0, Display: "0", disabled: false },
            { Key: 1, Display: "1", disabled: false },
            { Key: 2, Display: "2", disabled: false },
            { Key: 3, Display: "3 / 4", disabled: false },
        ];

        let errorMessage = null;

        if (
            (design_selected === "National Carport" || newJobState?.DesignSummary === "National Carport") &&
            subTypeSelected
        ) {
            const importanceLevel = newJobState?.SiteParameters?.ImportanceLevel || 2;

            if (typeof importanceLevel === "number" && importanceLevel >= 1 && importanceLevel <= 3) {
                const windZone =
                    newJobState?.SiteParameters?.WindData?.WindZoneAS1170?.calculated?.[
                        `importance_level_${importanceLevel}`
                    ]?.windzone_equiv || newJobState?.SiteParameters?.WindData?.WindZone;

                const windZoneLetter = windZone.charAt(0) || "";
                const windZoneNumber = parseInt(windZone.charAt(1), 10) || 0;
                const isSingle = subTypeSelected.includes("Single");

                // Start with function that disables all blocking options then modify as per wind zone
                let disableCondition = (item) => ({ ...item, disabled: true });

                if (windZoneLetter === "N") {
                    if (isSingle) {
                        if (windZoneNumber === 1) {
                            disableCondition = (item) => (item.Key >= 0 ? { ...item, disabled: false } : item);
                        } else if (windZoneNumber === 2) {
                            disableCondition = (item) => (item.Key === 3 ? { ...item, disabled: true } : item);
                        } else if (windZoneNumber === 3) {
                            disableCondition = (item) => (item.Key >= 2 ? { ...item, disabled: true } : item);
                        }
                    } else {
                        if (windZoneNumber === 1) {
                            disableCondition = (item) => (item.Key === 3 ? { ...item, disabled: true } : item);
                        } else if (windZoneNumber === 2) {
                            disableCondition = (item) => (item.Key >= 2 ? { ...item, disabled: true } : item);
                        } else if (windZoneNumber === 3) {
                            disableCondition = (item) => (item.Key >= 1 ? { ...item, disabled: true } : item);
                        }
                    }
                } else if (windZoneLetter === "C") {
                    if (isSingle) {
                        if (windZoneNumber === 1) {
                            disableCondition = (item) => (item.Key >= 2 ? { ...item, disabled: true } : item);
                        } else if (windZoneNumber === 2) {
                            disableCondition = (item) => (item.Key >= 1 ? { ...item, disabled: true } : item);
                        }
                    } else {
                        if (windZoneNumber === 1 || windZoneNumber === 2) {
                            disableCondition = (item) => (item.Key >= 2 ? { ...item, disabled: true } : item);
                        } else if (windZoneNumber === 3) {
                            disableCondition = (item) => (item.Key >= 1 ? { ...item, disabled: true } : item);
                        }
                    }
                }

                blocking = blocking.map(disableCondition);
                const allBlockingOptionsDisabled = blocking.every((item) => item.disabled === true);

                if (allBlockingOptionsDisabled) {
                    errorMessage = "There are no valid blocking options";
                    setCarportDisabled(true);
                    setCarportDisabledMessage("Unavailable at this location");
                    blockingRef.current.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                    });
                }
            }
        }

        const newErrorState = { ...errorState };
        newErrorState.SiteParameters = {
            ...newErrorState.SiteParameters,
            WindData: {
                ...newErrorState.SiteParameters?.WindData,
                Blocking: errorMessage,
            },
        };

        setErrorState(newErrorState);
        setBlockingOptionsExist(!errorMessage);
        setBlockingOptions(blocking);
    };

    const validateBlockingSelection = (newSelection = null) => {
        let blockingNumber =
            newSelection !== null && newSelection !== undefined
                ? newSelection
                : newJobState?.SiteParameters?.WindData?.Blocking || null;

        if (blockingNumber !== null && blockingNumber !== undefined && blockingOptionsExist) {
            let newBlockingSelection = blockingOptions.find((item) => item.Key === blockingNumber);
            let newState = { ...newJobState };

            if (!newBlockingSelection || newBlockingSelection.disabled) {
                let nextValidBlockingSelection = blockingOptions
                    .filter((item) => !item.disabled)
                    .reduce((max, item) => {
                        if (item.Key >= max.Key) {
                            return item;
                        } else {
                            return max;
                        }
                    });

                newBlockingSelection = nextValidBlockingSelection;
            }

            newState.SiteParameters.WindData.Blocking = newBlockingSelection?.Key || 0;

            if (newState.SiteParameters.ImportanceLevel === 1 && newBlockingSelection?.Key > 0) {
                newState.SiteParameters.ImportanceLevel = 2;
            }

            setNewJobState(newState);
        }
    };

    const updateDeckPageOpen = (value, finished = false) => {
        setDeckPageOpen(value);

        let updateNewJobState = newJobState;
        updateNewJobState.AreaSpecifications[0].SHAPE.Length = getDeckWidth({
            deckType: getDeckType({ deckState }),
            deckState,
            fixedState,
        });

        updateNewJobState.AreaSpecifications[0].SHAPE.Depth = getDeckHeight({
            deckType: getDeckType({ deckState }),
            deckState,
            fixedState,
        });

        updateNewJobState.AreaSpecifications[0].SHAPE.Height = deckState.deckStructure.deckHeight;

        // Add cutouts to L Shape
        if (getDeckType({ deckState }) === fixedState.deckStructure.deckShape[1]) {
            updateNewJobState.AreaSpecifications[0].SHAPE.CUTOUTS = getDeckCutout({
                cutouts: updateNewJobState.AreaSpecifications[0].SHAPE.CUTOUTS,
                deckState,
            });
        }

        // Add attachments
        if (deckState.deckAttachments) {
            // Reset all attachments
            updateNewJobState.AreaSpecifications[0].ATTACHMENTS["AttachmentRight"] = 0;
            updateNewJobState.AreaSpecifications[0].ATTACHMENTS["AttachmentBottom"] = 0;
            updateNewJobState.AreaSpecifications[0].ATTACHMENTS["AttachmentLeft"] = 0;
            updateNewJobState.AreaSpecifications[0].ATTACHMENTS["AttachmentTop"] = 0;
            updateNewJobState.AreaSpecifications[0].ATTACHMENTS["AttachmentModifications"] = [];

            const horizontal = false;

            if (getDeckType({ deckState }) === fixedState.deckStructure.deckShape[1]) {
                // L shape attachments

                let attachments = deckState.deckAttachments;
                const horizontal = false;
                const orientation = getRect2Orientation(deckState.deckStructure.deckRotation, horizontal);

                switch (orientation) {
                    case "bottom":
                        // frontleft
                        if (attachments.rect1.left === true || attachments.rect2.top === true) {
                            // In the cutout area add full attachment
                            updateNewJobState.AreaSpecifications[0].SHAPE["CUTOUTS"]["FrontLeft-Attachment"] = 1;
                        }
                        updateAttachments(deckState.deckAttachments.rect1, updateNewJobState, ["left"], horizontal);
                        updateAttachments(deckState.deckAttachments.rect2, updateNewJobState, ["top"], horizontal);
                        break;
                    case "left":
                        // backleft
                        if (attachments.rect1.top === true || attachments.rect2.right === true) {
                            // In the cutout area add full attachment
                            updateNewJobState.AreaSpecifications[0].SHAPE["CUTOUTS"]["BackLeft-Attachment"] = 1;
                        }
                        updateAttachments(deckState.deckAttachments.rect1, updateNewJobState, ["top"], horizontal);
                        updateAttachments(deckState.deckAttachments.rect2, updateNewJobState, ["right"], horizontal);
                        break;
                    case "top":
                        // backright
                        if (attachments.rect1.right === true || attachments.rect2.bottom === true) {
                            // In the cutout area add full attachment
                            updateNewJobState.AreaSpecifications[0].SHAPE["CUTOUTS"]["BackRight-Attachment"] = 1;
                        }
                        updateAttachments(deckState.deckAttachments.rect1, updateNewJobState, ["right"], horizontal);
                        updateAttachments(deckState.deckAttachments.rect2, updateNewJobState, ["bottom"], horizontal);
                        break;
                    default:
                        // 0 rotation - frontright
                        if (attachments.rect1.bottom === true || attachments.rect2.left === true) {
                            // In the cutout area add full attachment
                            updateNewJobState.AreaSpecifications[0].SHAPE["CUTOUTS"]["FrontRight-Attachment"] = 1;
                        }

                        updateAttachments(deckState.deckAttachments.rect1, updateNewJobState, ["bottom"], horizontal);
                        updateAttachments(deckState.deckAttachments.rect2, updateNewJobState, ["left"], horizontal);

                        break;
                }
            } else {
                // standard attachments
                // using only rect1
                updateAttachments(deckState.deckAttachments.rect1, updateNewJobState, [], horizontal);
            }
        }

        // Set Joist spacing
        if (deckState.deckMaterial) {
            // Regular expression to find the number inside parentheses
            const match = deckState.deckMaterial.match(/(\d+)mm \(([^)]+)\)/);

            if (match) {
                const number = toInteger(match[1]);
                updateNewJobState.AreaSpecifications[0].BEAMS_AND_POSTS.PurlinSpacing = number;
            }
        }

        let default_timber_attachment = {
            Ref: "Left 1",
            Name: "Left 1",
            WallOnly: 1,
            EaveWidth: 0,
            HasEaveWidth: 0,
            AttachmentLabel: "",
            AttachmentType: "Wall",
            FasciaType: "Wall",
            AttachmentVariation: "Timber With Beam",
            WallHeight: 900,
            HasWallHeight: 0,
            vOffset: 0,
            hOffset: 0,
            RoofAlignment: "Back",
            HasFasciaType: 1,
            NumBrackets: 0,
            HasNumBrackets: 0,
            AllowRSBLC: 0,
            HasBracketType: 0,
            BracketType: "Coach Screws @ 450 cts",
            BracketSpacing: 0,
            HasBeam: 1,
            WallType: "Timber Frame",
            RafterBracketTypeCode: "",
            WallBracketTypeCode: "",
            AttachmentBeamType: "FL15015",
        };

        let default_masonry_attachment = {
            Ref: "Left 1",
            Name: "Left 1",
            WallOnly: 1,
            EaveWidth: 0,
            HasEaveWidth: 0,
            AttachmentLabel: "",
            AttachmentType: "Wall",
            FasciaType: "Wall",
            AttachmentVariation: "Masonry Wall With Beam",
            WallHeight: 445,
            HasWallHeight: 1,
            vOffset: -45,
            hOffset: 0,
            RoofAlignment: "Side",
            HasFasciaType: 1,
            NumBrackets: 0,
            HasNumBrackets: 0,
            AllowRSBLC: 0,
            HasBracketType: 0,
            BracketType: "Masonry Anchors @ 450 cts",
            BracketSpacing: 0,
            HasBeam: 1,
            WallType: "Brick",
            RafterBracketTypeCode: "",
            WallBracketTypeCode: "",
            AttachmentBeamType: "FL15015",
        };

        // Set Attachment Type
        if (deckState.deckStructure.deckAttachment === fixedState.deckStructure.deckAttachment[1]) {
            // Timber
            const attachments = updateNewJobState.AreaSpecifications[0].ATTACHMENTS;
            if (attachments["AttachmentBottom"]) {
                let timber_attachment = { ...default_timber_attachment, Ref: "Front 1", Name: "Front 1" };
                updateNewJobState.AreaSpecifications[0].ATTACHMENTS.AttachmentModifications.push(timber_attachment);
            }
            if (attachments["AttachmentLeft"]) {
                let timber_attachment = { ...default_timber_attachment, Ref: "Left 1", Name: "Left 1" };
                updateNewJobState.AreaSpecifications[0].ATTACHMENTS.AttachmentModifications.push(timber_attachment);
            }
            if (attachments["AttachmentRight"]) {
                let timber_attachment = { ...default_timber_attachment, Ref: "Right 1", Name: "Right 1" };
                updateNewJobState.AreaSpecifications[0].ATTACHMENTS.AttachmentModifications.push(timber_attachment);
            }
            if (attachments["AttachmentTop"]) {
                let timber_attachment = { ...default_timber_attachment, Ref: "Back 1", Name: "Back 1" };
                updateNewJobState.AreaSpecifications[0].ATTACHMENTS.AttachmentModifications.push(timber_attachment);
            }

            // Get cutout attachments
            const cutoutAttachment = updateNewJobState.AreaSpecifications[0].SHAPE.CUTOUTS;
            if (cutoutAttachment["FrontLeft-CutoutType"] === "Step") {
                let timber_attachment = { ...default_timber_attachment, Ref: "CFL Y", Name: "CFL Y" };
                updateNewJobState.AreaSpecifications[0].ATTACHMENTS.AttachmentModifications.push(timber_attachment);
            }
            if (cutoutAttachment["BackLeft-CutoutType"] === "Step") {
                let timber_attachment = { ...default_timber_attachment, Ref: "CBL Y", Name: "CBL Y" };
                updateNewJobState.AreaSpecifications[0].ATTACHMENTS.AttachmentModifications.push(timber_attachment);
            }
            if (cutoutAttachment["FrontRight-CutoutType"] === "Step") {
                let timber_attachment = { ...default_timber_attachment, Ref: "CFR Y", Name: "CFR Y" };
                updateNewJobState.AreaSpecifications[0].ATTACHMENTS.AttachmentModifications.push(timber_attachment);
            }
            if (cutoutAttachment["BackRight-CutoutType"] === "Step") {
                let timber_attachment = { ...default_timber_attachment, Ref: "CBR Y", Name: "CBR Y" };
                updateNewJobState.AreaSpecifications[0].ATTACHMENTS.AttachmentModifications.push(timber_attachment);
            }
        } else if (deckState.deckStructure.deckAttachment === fixedState.deckStructure.deckAttachment[0]) {
            // Masonry
            const attachments = updateNewJobState.AreaSpecifications[0].ATTACHMENTS;
            if (attachments["AttachmentBottom"]) {
                let masonry_attachment = { ...default_masonry_attachment, Ref: "Front 1", Name: "Front 1" };
                updateNewJobState.AreaSpecifications[0].ATTACHMENTS.AttachmentModifications.push(masonry_attachment);
            }
            if (attachments["AttachmentLeft"]) {
                let masonry_attachment = { ...default_masonry_attachment, Ref: "Left 1", Name: "Left 1" };
                updateNewJobState.AreaSpecifications[0].ATTACHMENTS.AttachmentModifications.push(masonry_attachment);
            }
            if (attachments["AttachmentRight"]) {
                let masonry_attachment = { ...default_masonry_attachment, Ref: "Right 1", Name: "Right 1" };
                updateNewJobState.AreaSpecifications[0].ATTACHMENTS.AttachmentModifications.push(masonry_attachment);
            }
            if (attachments["AttachmentTop"]) {
                let masonry_attachment = { ...default_masonry_attachment, Ref: "Back 1", Name: "Back 1" };
                updateNewJobState.AreaSpecifications[0].ATTACHMENTS.AttachmentModifications.push(masonry_attachment);
            }

            // Get cutout attachments
            const cutoutAttachment = updateNewJobState.AreaSpecifications[0].SHAPE.CUTOUTS;
            if (cutoutAttachment["FrontLeft-CutoutType"] === "Step") {
                let masonry_attachment = { ...default_masonry_attachment, Ref: "CFL Y", Name: "CFL Y" };
                updateNewJobState.AreaSpecifications[0].ATTACHMENTS.AttachmentModifications.push(masonry_attachment);
            }
            if (cutoutAttachment["BackLeft-CutoutType"] === "Step") {
                let masonry_attachment = { ...default_masonry_attachment, Ref: "CBL Y", Name: "CBL Y" };
                updateNewJobState.AreaSpecifications[0].ATTACHMENTS.AttachmentModifications.push(masonry_attachment);
            }
            if (cutoutAttachment["FrontRight-CutoutType"] === "Step") {
                let masonry_attachment = { ...default_masonry_attachment, Ref: "CFR Y", Name: "CFR Y" };
                updateNewJobState.AreaSpecifications[0].ATTACHMENTS.AttachmentModifications.push(masonry_attachment);
            }
            if (cutoutAttachment["BackRight-CutoutType"] === "Step") {
                let masonry_attachment = { ...default_masonry_attachment, Ref: "CBR Y", Name: "CBR Y" };
                updateNewJobState.AreaSpecifications[0].ATTACHMENTS.AttachmentModifications.push(masonry_attachment);
            }
            // Set the accepted condition
            updateNewJobState.AcceptedWarnings = ["MASONRY CONDITIONS ACCEPTED BY " + app?.user?.DisplayName];
        }

        setNewJobState(updateNewJobState);

        // Create the job
        if (finished) validateAndCreate();
    };

    const validateAndCreate = () => {
        let object_has_content = checkDoesObjectHaveContent(errorState);

        // Disabled for now
        if (object_has_content?.value === "License not valid for address.") {
            object_has_content = null;
        }

        if (object_has_content) {
            setShowMessage({
                type: "error",
                message: "Error: " + object_has_content.value,
            });
            dispatch({
                type: SHOW_DESIGNER_MESSAGE,
                message: {
                    message: "Error: " + object_has_content.value,
                    type: "error",
                },
            });

            if (object_has_content.value.includes("Job Name") || object_has_content.key === "JobName") {
                jobNameRef.current.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                });
            }
            if (object_has_content.value.toLowerCase().includes("address")) {
                siteAddressRef.current.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                });
            }
            if (object_has_content.value.includes("Wind Data")) {
                windDateRef.current.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                });
            }
            if (object_has_content.value.includes("Blocking")) {
                blockingRef.current.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                });
            }

            return;
        }

        const existingNSDA = newJobState?.SiteParameters?.NonStandardDeliveryArea ?? null;
        const existingHistoryRaw = Array.isArray(existingNSDA?.AreaHistory) ? existingNSDA.AreaHistory : [];

        const hasNewRecord = Boolean(newNonStdDelRecord?.Id);
        const shouldIncludeNSDA = Boolean(existingNSDA) || hasNewRecord || errorLoadingDeliveryArea;

        const existingId = existingNSDA?.CurrentId ?? null;
        const newId = hasNewRecord ? newNonStdDelRecord.Id : null;

        let newHistory = existingHistoryRaw;

        if (hasNewRecord) {
            const idx = existingHistoryRaw.findIndex((h) => h?.Id === newId);

            if (idx >= 0) {
                newHistory = existingHistoryRaw.map((h, i) =>
                    i === idx ? { ...h, AcknowledgedAt: newNonStdDelRecord.AcknowledgedAt } : h
                );
            } else {
                newHistory = [...existingHistoryRaw, newNonStdDelRecord];
            }
        }

        let nextCurrentId = existingId;

        if (errorLoadingDeliveryArea || isLoadingDeliveryArea) {
            nextCurrentId = "error";
        } else if (hasNewRecord) {
            nextCurrentId = newId;
        } else {
            nextCurrentId = null;
        }

        const nonStdDeliveryArea = shouldIncludeNSDA
            ? {
                  ...existingNSDA,
                  CurrentId: nextCurrentId,
                  AreaHistory: newHistory,
              }
            : undefined;

        const jobToSubmit = {
            ...newJobState,
            Customer: {
                ...(newJobState.Customer ?? {}),
                SortLastName: (newJobState.Customer?.LastName ?? "").toLowerCase().trim(),
                SortFirstName: (newJobState.Customer?.FirstName ?? "").toLowerCase().trim(),
            },
            SiteParameters: {
                ...(newJobState.SiteParameters ?? {}),
                Address: {
                    ...(newJobState.SiteParameters?.Address ?? {}),
                    SortSuburb: (newJobState.SiteParameters?.Address?.Suburb ?? "").toLowerCase().trim(),
                },
                ...(nonStdDeliveryArea ? { NonStandardDeliveryArea: nonStdDeliveryArea } : {}),
            },
            preprod: window.location.href.includes("preprod"),
        };

        if (editMode) {
            if (!props.job?.App?.Locked) {
                let new_job_data = validateFullJob(config, deepCopy(jobToSubmit), -1, app);

                dispatch({
                    type: NEW_JOB,
                    parameter: new_job_data,
                });

                if (job) {
                    if (
                        job?.DesignParameters?.CustomisedOffering !== new_job_data?.DesignParameters?.CustomisedOffering
                    ) {
                        dispatch(CONFIG.loadOffering(new_job_data));
                    }
                }
            }

            dispatch(toggleDesigner(SHOW_CUSTOMER_JOB_PANEL));

            return;
        }

        if (duplicateMode) {
            dispatch(newDuplicateJob(user, jobToSubmit)).then((result) => {
                if (result && typeof result === "string" && result.startsWith("ERROR")) {
                    dispatch(SetAppDialogMessage(result));
                } else {
                    dispatch(updateUserFromWeb(logged_user_id));
                    dispatch(changePage(DESIGNER_PAGE));
                    dispatch(changeMainPage("Recall"));
                    dispatch(resetDesigner());
                }
            });

            return;
        }

        dispatch(newJob(user, jobToSubmit, design_selected, subTypeSelected)).then((result) => {
            if (result && typeof result === "string" && result.startsWith("ERROR")) {
                dispatch(SetAppDialogMessage(result));
            } else {
                dispatch(updateUserFromWeb(logged_user_id));
                dispatch(changePage(DESIGNER_PAGE));
                dispatch(changeMainPage("Recall"));
                dispatch(resetDesigner());
            }
        });
    };

    const onChangelatLng = debounce((coords) => {
        setLatLang(coords);
    }, 200);

    const resetWindData = () => {
        let newState = newJobState;
        if (newState.SiteParameters.WindData && newState.SiteParameters.WindData.WindZoneAS1170) {
            delete newState.SiteParameters.WindData.WindZoneAS1170;
            setNewJobState(newState);
        }
    };

    const updateWind = () => {
        resetWindData();
    };

    const handleUpdateDistributor = (e) => {
        // Reset Dist State
        handleStateUpdate("Customer", "DistLevel", "");
        let code = e.target.value;

        //load business data
        let api_url = API_BASE() + "business/" + code;
        fetchTimeout(api_url, {
            method: "GET",
        })
            .then((response) => response.json())
            .then((json) => {
                if (json?.id === code) {
                    let newState = { ...newJobState };
                    if (!editMode) newState.BusinessCode = code;
                    newState.Distributor = json;
                    setNewJobState(newState);

                    //update config to offering
                    let region = newState?.Distributor?.Offer?.Regions?.[0];
                    if (region && config && region !== config.id) {
                        // save this offering
                        let brand = newState?.Distributor?.Offer?.Brand;
                        let region_offering = newState?.Distributor?.Offer?.offerings?.[region];
                        if (!region_offering) region_offering = app?.offerings?.[brand]?.Regions?.[region];
                        if (region_offering) {
                            let new_config = mergeDeep({ ..._cloneDeep(app.offerings[brand].Master) }, region_offering);
                            dispatch(CONFIG.updateConfigAll(new_config));
                        }
                    }
                }
            })
            .catch((e) => {});
    };

    const handleUpdateSalesContact = (e) => {
        if (e.target.value && e.target.value !== selectedSalesContact?.id) {
            const contact = salesContacts.find((salesContact) => salesContact.id === e.target.value);

            if (contact) {
                let newState = { ...newJobState };
                newState.User = contact;
                newState.UserID = contact?.id || "";

                setSelectedSalesContact(contact);
                setNewJobState(newState);
            }
        }
    };

    const validateSiteAddress = (address) => {
        let street_name = address?.Street;
        if (address?.Street_short_name && address?.FormattedAddress?.includes(address.Street_short_name)) {
            street_name = address.Street_short_name;
        }
        let suburb_name = address?.Suburb;
        if (address?.Suburb_short_name && address?.FormattedAddress?.includes(address.Suburb_short_name)) {
            suburb_name = address.Suburb_short_name;
        }
        if (
            address?.FormattedAddress?.trim().length < 8 ||
            (suburb_name &&
                street_name &&
                (!address?.FormattedAddress?.includes(suburb_name) ||
                    !address?.FormattedAddress?.includes(street_name)))
        ) {
            address.StreetNumber = "";
            address.Street = "";
            address.Suburb = "";
            address.State = "";
            address.LatLng = null;
            siteAddressLatLngRef.current = null;
            resetWindData();
        }

        let error = checkJobStateValidationSchema(
            validationSchema,
            "SiteParameters",
            "Address",
            "FormattedAddress",
            address?.FormattedAddress
        );

        if (!error) {
            if (address?.FormattedAddress?.trim().length < 8) {
                error = "Please provide a more specific address, including suburb.";
            } else if (!address?.LatLng?.lat) {
                error = "Unable to geolocate this address.";
            }
        }

        return { address: address, error: error };
    };

    let windDataAS1170 = newJobState?.SiteParameters?.WindData?.WindZoneAS1170;
    let windDataText = "Location not set... wind data is required before proceeding...";

    if (siteAddressLatLng) {
        if (!windDataAS1170) {
        } else {
            windDataText = (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <div style={{ padding: "5px", width: "100%" }}>
                        AS1170-2021 WIND SUMMARY for {windDataAS1170.latlng}
                        <br />
                        {windDataAS1170.address}
                        <br />
                        Critical: {windDataAS1170.critical} | Elev: {windDataAS1170.elevation}m | Region:{" "}
                        {windDataAS1170.region}
                        <br />
                        {newJobState?.SiteParameters?.ImportanceLevel === 1 && (
                            <>
                                Importance Level 1:{" "}
                                {windDataAS1170.calculated.importance_level_1.base_pressure.toFixed(2)} kPa | WZ Equiv:{" "}
                                {windDataAS1170.calculated.importance_level_1.windzone_estimate}
                            </>
                        )}
                        {(newJobState?.SiteParameters?.ImportanceLevel === 2 ||
                            !newJobState?.SiteParameters?.ImportanceLevel) && (
                            <>
                                Importance Level 2:{" "}
                                {windDataAS1170.calculated.importance_level_2.base_pressure.toFixed(2)} kPa | WZ Equiv:{" "}
                                {windDataAS1170.calculated.importance_level_2.windzone_estimate}
                            </>
                        )}
                        {newJobState?.SiteParameters?.ImportanceLevel === 3 && (
                            <>
                                Importance Level 3 (Major Structure):{" "}
                                {windDataAS1170.calculated.importance_level_3.base_pressure.toFixed(2)} kPa | WZ Equiv:{" "}
                                {windDataAS1170.calculated.importance_level_3.windzone_estimate}
                            </>
                        )}
                        {(toNumber(user?.Role) >= 92 || user.RoleName === "Super") && (
                            <>
                                <br />
                                Data Source: {windDataAS1170?.from_cache ? "Cache" : "Revolutio"}{" "}
                                <span className="link" onClick={() => setShowWindDetails(true)}>
                                    {" "}
                                    [details]
                                </span>
                            </>
                        )}
                        <div style={{ textAlign: "right" }}>
                            <p style={{ marginBottom: "0px" }}>
                                <i>Data provided by Revolutio Hazard API</i>
                            </p>
                        </div>
                    </div>
                </div>
            );
        }
    }

    const this_MANUFACTURER = objectByString(MANUFACTURER, window.brand);
    let headerString = objectByString(classes, "header");
    let sectionHeaderString = objectByString(classes, "sectionHeader");

    if (toUpper(this_MANUFACTURER?.Name) === "LYSAGHT") {
        headerString = objectByString(classes, "headerLysaght");
        sectionHeaderString = objectByString(classes, "sectionHeaderLysaght");
    }

    let isSelectEnabled = false;
    let selectedLicense =
        businessList && businessList?.find
            ? businessList.find((e) => e.id === Distributor.Code && e?.Type === "BBC")
            : false;

    if (selectedLicense) isSelectEnabled = true;

    let blockingValue = null;

    if (blockingOptionsExist) {
        if (newJobState?.SiteParameters?.WindData?.Blocking !== undefined) {
            blockingValue = newJobState?.SiteParameters?.WindData?.Blocking;
        } else {
            blockingValue = 1;
        }
    }

    let louvre_access_level = 90;

    if (config?.design_options["Louvre Roof"]?.access_level) {
        louvre_access_level = toNumber(config?.design_options["Louvre Roof"]?.access_level);
    }

    let annual_exceedance_prob_auto =
        newJobState?.SiteParameters?.WindData?.WindZoneAS1170?.calculated?.[
            `importance_level_${
                newJobState?.SiteParameters?.ImportanceLevel ? newJobState?.SiteParameters?.ImportanceLevel : 2
            }`
        ]?.annual_exceedance_prob;

    if (APP_LOAD_WIND_DATA && !APP_SHOW_CUSTOMER_JOB_PANEL) {
        return <div className={classes.root}></div>;
    }

    let bgClass = classes.greenBG;

    if (isNonStdDelivery || errorLoadingDeliveryArea) bgClass = classes.orangeBG;
    if (isLoadingDeliveryArea) bgClass = classes.windSpeed;
    if (!newJobState?.SiteParameters?.Address?.PostCode) bgClass = classes.windSpeed;

    return (
        <div className={classes.root}>
            {/* Temporarily disabled */}
            {newJobState?.Distributor?.POA && false && (
                <NonStandardDeliveryCheck
                    siteParameters={newJobState?.SiteParameters}
                    poa={newJobState?.Distributor?.POA}
                    account={newJobState?.Customer?.DistLevel || newJobState?.Distributor?.LYVESAccount}
                    isNonStandardDelivery={isNonStdDelivery}
                    setIsNonStdDelivery={setIsNonStdDelivery}
                    hasAcknowledged={hasAckNonStdDelivery}
                    setHasAcknowledged={setHasAckNonStdDelivery}
                    setLoading={setIsLoadingDeliveryArea}
                    error={errorLoadingDeliveryArea}
                    setError={setErrorLoadingDeliveryArea}
                    displayElement={deliveryAreaRef}
                />
            )}
            {editMode && (
                <FrameAppBar
                    title=""
                    onClick={() => dispatch(toggleDesigner(SHOW_CUSTOMER_JOB_PANEL))}
                    button1Text={!allowSave && windDataLoading ? "Awaiting Wind Data" : "Save Changes"}
                    button1Click={validateAndCreate}
                    disabled={!allowSave}
                />
            )}
            <div className={classes.page} ref={topRef}>
                <div style={{ marginTop: "50px", marginBottom: "100px" }}>
                    <div
                        style={{
                            marginBottom: "40px",
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        {newMode && <span className={headerString}>New Job</span>}
                        {editMode && <span className={headerString}></span>}
                        {duplicateMode && (
                            <>
                                <span className={headerString}>Duplicate Job</span>
                                <span className={sectionHeaderString}>*edit any details before proceeding</span>
                            </>
                        )}
                    </div>
                    {duplicateMode && (
                        <object className={classes.media} data={image_url} type="image/png">
                            <img
                                className={classes.media}
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAikAAAEYBAMAAABrc3u4AAAALHRFWHRDcmVhdGlvbiBUaW1lAFdlZCAyNyBNYXIgMjAxOSAxODo1MTo0NyArMDkzMOWZz+IAAAAHdElNRQfjAxsIHCk2av1LAAAACXBIWXMAAAsSAAALEgHS3X78AAAABGdBTUEAALGPC/xhBQAAAANQTFRFlJylJii/hwAAAGJJREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB4NDAfAAHd3L3XAAAAAElFTkSuQmCC"
                                alt="Thumbnail"
                            />
                        </object>
                    )}

                    {toNumber(user?.Role) >= 90 && (
                        <>
                            <div className={classes.sectionContainer}>
                                <div className={sectionHeaderString}>Distributor</div>
                                <div className={classes.sectionContent}>
                                    <div className={classes.sectionSubSection}>
                                        <BSL_Select
                                            label="Distributor"
                                            value={Distributor.Code}
                                            items={businessesSorted}
                                            onChange={handleUpdateDistributor}
                                        />
                                        <BSL_FilterSelect
                                            style={{
                                                padding: "4px 26px 4px 12px",
                                                margin: "2px 2px 2px 8px",
                                                padding: "6px 0px 6px 0px",
                                            }}
                                            isDisabled={!isSelectEnabled}
                                            disabledTooltip="Distributor must be a BBC license to modify pricing."
                                            label="Pricing Tier"
                                            options={account_tiers}
                                            value={selectedPricingTier}
                                            onChange={(e) => {
                                                handleStateUpdate("Customer", "DistLevel", e.value);
                                            }}
                                        />
                                    </div>
                                    <div className={classes.sectionSubSection}>
                                        <BSL_Select
                                            label="Sales Contact"
                                            value={selectedSalesContact?.id || ""}
                                            items={salesContacts.map((contact) => ({
                                                Key: contact?.id,
                                                Display: contact?.DisplayName,
                                            }))}
                                            onChange={handleUpdateSalesContact}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={classes.divider} />
                        </>
                    )}

                    {toNumber(user?.Role) < 90 && (
                        <>
                            <div className={classes.sectionContainer}>
                                <div className={sectionHeaderString}>Distributor</div>
                                <div className={classes.sectionContent}>
                                    <div className={classes.sectionSubSection}>
                                        <BSL_Select
                                            label="Distributor"
                                            value={Distributor.Code}
                                            items={businessesSorted}
                                            onChange={handleUpdateDistributor}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={classes.divider} />
                        </>
                    )}

                    <div className={classes.sectionContainer}>
                        <div className={sectionHeaderString}>Customer</div>
                        <div className={classes.sectionContent}>
                            <Box className={classes.sectionSubSection}>
                                <AddressAutoComplete
                                    key="customer_address"
                                    id="customer_address"
                                    label_text="Mailing Address"
                                    optional
                                    address={newJobState.Customer["Address"]}
                                    updateWind={
                                        newJobState.SiteParameters.AddressSameAsMailingAddress ? updateWind : null
                                    }
                                    onChangelatLng={
                                        newJobState.SiteParameters.AddressSameAsMailingAddress ? onChangelatLng : null
                                    }
                                    onChange={(address) => {
                                        if (newJobState.SiteParameters.AddressSameAsMailingAddress) {
                                            let newState = { ...newJobState };
                                            newState["Customer"]["Address"] = address;
                                            newState["SiteParameters"]["Address"] = address;
                                            setNewJobState(newState);

                                            let newErrorState = { ...errorState };
                                            if (newErrorState?.Customer?.Address?.FormattedAddress) {
                                                newErrorState.Customer.Address = {
                                                    FormattedAddress: null,
                                                };
                                            }
                                        } else {
                                            handleStateUpdate("Customer", "Address", null, address);
                                        }
                                    }}
                                    onBlur={(address) => {
                                        if (newJobState.SiteParameters.AddressSameAsMailingAddress) {
                                            let validation_result = validateSiteAddress(address);
                                            address = validation_result.address;

                                            let newState = { ...newJobState };
                                            newState["Customer"]["Address"] = address;
                                            newState["SiteParameters"]["Address"] = address;
                                            setNewJobState(newState);

                                            let newErrorState = { ...errorState };

                                            if (!newErrorState?.Customer?.Address?.FormattedAddress)
                                                newErrorState.Customer.Address = {
                                                    FormattedAddress:
                                                        validation_result.error == null
                                                            ? null
                                                            : validation_result.error +
                                                              " (required as site address is matched to this address)",
                                                };
                                            else
                                                newErrorState.Customer.Address.FormattedAddress =
                                                    validation_result.error == null
                                                        ? null
                                                        : validation_result.error +
                                                          " (required as site address is matched to this address)";

                                            if (!newErrorState?.SiteParameters?.Address?.FormattedAddress)
                                                newErrorState.SiteParameters.Address = {
                                                    FormattedAddress: validation_result.error,
                                                };
                                            else
                                                newErrorState.SiteParameters.Address.FormattedAddress =
                                                    validation_result.error;

                                            setErrorState(newErrorState);
                                        } else {
                                            handleStateUpdate("Customer", "Address", null, address);
                                        }
                                    }}
                                    enableMap={false}
                                    error={errorState?.Customer?.Address?.FormattedAddress}
                                    helperText={"You can specify the site address separately below."}
                                />
                            </Box>
                            <div className={classes.sectionSubSection}>
                                <BSL_TextInput
                                    label="First Name"
                                    preValidate="name"
                                    value={newJobState.Customer.FirstName}
                                    optional
                                    onBlur={(e) => {
                                        handleStateUpdate("Customer", "FirstName", e);
                                    }}
                                    error={errorState.Customer.FirstName}
                                />
                                <BSL_TextInput
                                    label="Last Name"
                                    preValidate="name"
                                    value={newJobState.Customer.LastName}
                                    optional
                                    onBlur={(e) => {
                                        handleStateUpdate("Customer", "LastName", e);
                                    }}
                                    error={errorState.Customer.LastName}
                                />
                            </div>
                            <div className={classes.sectionSubSection}>
                                <BSL_TextInput
                                    label="Phone"
                                    preValidate="alphaNumeric"
                                    value={newJobState.Customer.Phone}
                                    optional
                                    onBlur={(e) => {
                                        handleStateUpdate("Customer", "Phone", e);
                                    }}
                                    error={errorState.Customer.Phone}
                                />
                                <BSL_TextInput
                                    label="Email"
                                    value={newJobState.Customer.Email}
                                    optional
                                    onBlur={(e) => {
                                        handleStateUpdate("Customer", "Email", e);
                                    }}
                                    error={errorState.Customer.Email}
                                />
                            </div>

                            <div className={classes.sectionSubSection}>
                                <BSL_Select
                                    label="Customer Type"
                                    value={Customer.Type}
                                    items={customer_types}
                                    onChange={(e) => {
                                        handleStateUpdate("Customer", "Type", e);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={classes.divider} />
                    <div className={classes.sectionContainer}>
                        <div className={sectionHeaderString}>Job Details</div>
                        <div className={classes.sectionContent}>
                            <div className={classes.sectionSubSection} ref={jobNameRef}>
                                <BSL_TextInput
                                    label="Job Name"
                                    value={newJobState.Customer.JobName}
                                    onBlur={(e) => {
                                        handleStateUpdate("Customer", "JobName", e);
                                    }}
                                    helperText={"Your own unique reference for this project (max. 30 characters)."}
                                    error={errorState.Customer.JobName}
                                />
                            </div>
                            {props.mode === "Edit" && (
                                <BSL_ControlContainer label={"Job Status"} style={{ color: "white" }}>
                                    <BSL_StatusChip
                                        status={newJobState.Status}
                                        job_id={newJobState.id}
                                        newJobState={newJobState}
                                        setNewJobState={setNewJobState}
                                    />
                                </BSL_ControlContainer>
                            )}
                            <div
                                className={classes.sectionSubSection}
                                style={{ flexDirection: "column" }}
                                ref={siteAddressRef}
                            >
                                <BSL_CheckBox
                                    style={{ padding: "16px 8px 0px 0px" }}
                                    main_label="Site Address"
                                    label="Same as Mailing Address"
                                    checked={newJobState.SiteParameters.AddressSameAsMailingAddress}
                                    onChange={(checked) => {
                                        handleStateUpdate(
                                            "SiteParameters",
                                            "AddressSameAsMailingAddress",
                                            null,
                                            checked
                                        );
                                        if (checked) {
                                            let validation_result = validateSiteAddress(
                                                newJobState.Customer["Address"]
                                            );
                                            handleStateUpdate(
                                                "SiteParameters",
                                                "Address",
                                                null,
                                                validation_result.address
                                            );

                                            let newErrorState = { ...errorState };

                                            if (!newErrorState?.SiteParameters?.Address?.FormattedAddress) {
                                                newErrorState.SiteParameters.Address = {
                                                    FormattedAddress: validation_result.error,
                                                };
                                            } else {
                                                newErrorState.SiteParameters.Address.FormattedAddress =
                                                    validation_result.error;
                                            }

                                            setErrorState(newErrorState);
                                        }
                                    }}
                                />
                                <Box className={classes.sectionSubSection}>
                                    <AddressAutoComplete
                                        key="site_address"
                                        id="site_address"
                                        optional
                                        updateWind={updateWind}
                                        onBlur={(address) => {
                                            let validation_result = validateSiteAddress(address);
                                            handleStateUpdate(
                                                "SiteParameters",
                                                "Address",
                                                null,
                                                validation_result.address
                                            );

                                            let newErrorState = { ...errorState };

                                            if (!newErrorState?.SiteParameters?.Address?.FormattedAddress) {
                                                newErrorState.SiteParameters.Address = {
                                                    FormattedAddress: validation_result.error,
                                                };
                                            } else {
                                                newErrorState.SiteParameters.Address.FormattedAddress =
                                                    validation_result.error;
                                            }

                                            setErrorState(newErrorState);
                                        }}
                                        onChangelatLng={onChangelatLng}
                                        disabled={newJobState.SiteParameters.AddressSameAsMailingAddress}
                                        address={newJobState.SiteParameters["Address"]}
                                        onChange={(address) => {
                                            let newState = { ...newJobState };
                                            newState["Customer"]["Address"] = address;
                                            newState["SiteParameters"]["Address"] = address;
                                            setNewJobState(newState);

                                            let newErrorState = { ...errorState };
                                            if (newErrorState?.SiteParameters?.Address?.FormattedAddress) {
                                                newErrorState.SiteParameters.Address = {
                                                    FormattedAddress: null,
                                                };
                                            }
                                        }}
                                        enableMap={true}
                                        allowMapDrag={!editMode}
                                        helperText={
                                            "Position the map marker to the exact position (not just the lot) you intend to place the structure. (Several meters can make a difference to wind blocking action)."
                                        }
                                        error={errorState?.SiteParameters?.Address?.FormattedAddress}
                                    />
                                </Box>
                                <div className={classes.subHeader} style={{ alignSelf: "center", padding: "0px" }}>
                                    LatLng:{" "}
                                    {siteAddressLatLng &&
                                    typeof siteAddressLatLng.lat === "number" &&
                                    typeof siteAddressLatLng.lng === "number"
                                        ? siteAddressLatLng.lat.toFixed(6) + "," + siteAddressLatLng.lng.toFixed(6)
                                        : " Unknown"}
                                </div>
                                {/* Temporarily disabled */}
                                {false && (
                                    <div
                                        className={classes.sectionSubSection}
                                        style={{ padding: "20px 8px 0px 8px", flexDirection: "column" }}
                                    >
                                        <div className={classes.subHeader}>Delivery Area</div>
                                        {!newJobState?.SiteParameters?.Address?.PostCode && (
                                            <div
                                                className="error"
                                                style={{
                                                    font: "13px 'canada-type-gibson', sans-serif",
                                                    marginBottom: "4px",
                                                }}
                                            >
                                                <ErrorOutlineIcon
                                                    style={{
                                                        width: "16px",
                                                        height: "16px",
                                                        marginRight: "8px",
                                                    }}
                                                />
                                                Location not set
                                            </div>
                                        )}

                                        <Paper className={bgClass} elevation={3}>
                                            <div ref={deliveryAreaRef}>
                                                {(() => {
                                                    if (isLoadingDeliveryArea) return <LinearProgress />;

                                                    if (!newJobState?.SiteParameters?.Address?.PostCode) {
                                                        return <div>*NO SITE ADDRESS*</div>;
                                                    }

                                                    if (errorLoadingDeliveryArea) {
                                                        return (
                                                            <>
                                                                <div>
                                                                    We've been unable to determine if this job falls
                                                                    within a standard delivery area.
                                                                </div>
                                                                <br />
                                                                <div>
                                                                    Please continue and we'll prompt you to try again
                                                                    later.
                                                                </div>
                                                            </>
                                                        );
                                                    }

                                                    if (isNonStdDelivery) {
                                                        return (
                                                            <>
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        flexDirection: "row",
                                                                        alignItems: "center",
                                                                    }}
                                                                >
                                                                    <BSL_CheckBox checked={hasAckNonStdDelivery} />
                                                                    <div>
                                                                        I acknowledge this address falls outside our
                                                                        standard delivery area and will incur an
                                                                        additional charge.
                                                                    </div>
                                                                </div>
                                                                <br />
                                                                <div>
                                                                    Please contact your order manager for further
                                                                    details.
                                                                </div>
                                                            </>
                                                        );
                                                    }

                                                    return "This address falls within our standard delivery area.";
                                                })()}
                                            </div>
                                        </Paper>
                                    </div>
                                )}
                                <div className={classes.sectionSubSection}>
                                    <BSL_TextInput
                                        label="Lot and plan details"
                                        preValidate="alphaNumeric"
                                        value={newJobState.Customer.LotPlanDetails}
                                        optional
                                        onBlur={(e) => {
                                            handleStateUpdate("Customer", "LotPlanDetails", e);
                                        }}
                                        error={errorState.Customer.LotPlanDetails}
                                    />
                                </div>
                                <div className={classes.sectionSubSection}>
                                    <BSL_TextInput
                                        label="Local government area where the land is situated"
                                        value={newJobState.Customer.LocalGovArea}
                                        optional
                                        onBlur={(e) => {
                                            handleStateUpdate("Customer", "LocalGovArea", e);
                                        }}
                                        error={errorState.Customer.LocalGovArea}
                                    />
                                </div>
                            </div>
                            <div
                                className={classes.sectionSubSection}
                                style={{ padding: "20px 8px 0px 8px", flexDirection: "column" }}
                            >
                                <div className={classes.subHeader} ref={windDateRef}>
                                    Wind Data
                                </div>
                                {!newJobState.SiteParameters.WindData.WindZoneAS1170 && (
                                    <div
                                        className="error"
                                        style={{ font: "13px 'canada-type-gibson', sans-serif", marginBottom: "4px" }}
                                    >
                                        <ErrorOutlineIcon
                                            style={{
                                                width: "16px",
                                                height: "16px",
                                                marginRight: "8px",
                                            }}
                                        />
                                        {!siteAddressLatLng
                                            ? "Location not set"
                                            : "Wind data will be automatically retrieved. You can continue " +
                                              (editMode ? "Saving " : "Creating ") +
                                              "the job."}
                                    </div>
                                )}

                                <Paper
                                    className={classes.windSpeed + " " + (windDataAS1170 ? classes.greenBG : "")}
                                    elevation={3}
                                >
                                    {newJobState.SiteParameters.WindData.WindZoneAS1170 && <div>{windDataText}</div>}
                                    {!newJobState.SiteParameters.WindData.WindZoneAS1170 && <div>*NO WIND DATA*</div>}
                                    {!newJobState.SiteParameters.WindData.WindZoneAS1170 && errorWindDataLoading && (
                                        <div className={classes.errorText}>{errorWindDataLoading}</div>
                                    )}

                                    {windDataLoading && <LinearProgress />}
                                </Paper>
                            </div>

                            <div
                                className={classes.sectionSubSection}
                                style={{ padding: "0px 8px", flexDirection: "column" }}
                            >
                                <div className={classes.subHeader} ref={blockingRef}>
                                    Blocking <HelpButton section="blocking" />
                                </div>
                                <div style={{ display: "flex" }}>
                                    <SegmentedButtonGroup
                                        value={blockingValue}
                                        style={{
                                            flex: "none",
                                        }}
                                        items={blockingOptions}
                                        onChange={(e, val) => {
                                            validateBlockingSelection(val);
                                        }}
                                        disabled={!blockingOptionsExist}
                                        error={errorState?.SiteParameters?.WindData?.Blocking}
                                        testId="blocking-segmented-button-group"
                                    />
                                    <div className={classes.subHeader} style={{ flex: 1, padding: "0px 8px" }}>
                                        Sides Blocked
                                    </div>
                                </div>
                            </div>

                            <div
                                className={classes.sectionSubSection}
                                style={{ padding: "4px 8px", flexDirection: "column" }}
                            >
                                <div className={classes.subHeader}>
                                    Importance Level <HelpButton section="jobtype" />
                                </div>
                                <Tooltip
                                    arrow
                                    placement="top-end"
                                    title={
                                        <p style={{ color: "lightblue", fontSize: "14px" }}>If Unsure, View Help.</p>
                                    }
                                >
                                    <div>
                                        <SegmentedButtonGroup
                                            value={
                                                newJobState?.SiteParameters?.ImportanceLevel
                                                    ? newJobState?.SiteParameters?.ImportanceLevel
                                                    : 2
                                            }
                                            items={[
                                                {
                                                    Key: 1,
                                                    Display: "Importance L1",
                                                    disabled: newJobState?.SiteParameters?.WindData?.Blocking > 0,
                                                },
                                                { Key: 2, Display: "Importance L2" },
                                                { Key: 3, Display: "Importance L3" },
                                            ]}
                                            onChange={(e, val) => {
                                                if (val === 1) setOpenImportanceLevel1Dialog(true);
                                                else handleStateUpdate("SiteParameters", "ImportanceLevel", null, val);
                                            }}
                                        />
                                        <SegmentedButtonGroup
                                            label="Set Annual Probability of Exceedance"
                                            value={newJobState?.DesignParameters?.vr_mode ?? 0}
                                            items={[
                                                {
                                                    Key: 0,
                                                    Display:
                                                        "Auto" +
                                                        (annual_exceedance_prob_auto
                                                            ? " (1/" + annual_exceedance_prob_auto + ")"
                                                            : ""),
                                                },
                                                { Key: 500, Display: "1/500" },
                                                { Key: 1000, Display: "1/1000" },
                                            ]}
                                            onChange={(e, val) => {
                                                handleStateUpdate("DesignParameters", "vr_mode", null, val);
                                            }}
                                        />
                                    </div>
                                </Tooltip>
                            </div>

                            <BSL_Dialog
                                title="Importance Level 1 Information and Agreement"
                                open={openImportanceLevel1Dialog}
                                onClose={() => setOpenImportanceLevel1Dialog(false)}
                                button1Text="I Agree"
                                button1Click={() => {
                                    setOpenImportanceLevel1Dialog(false);
                                    const today = new Date(Date.now());

                                    let notes = newJobState?.Notes ? [...newJobState.Notes] : [];
                                    notes.push({
                                        timestamp: new Date().getTime(),
                                        system_generated: true,
                                        user: user.id,
                                        user_code: user.UserCode,
                                        user_role: user.RoleName,
                                        text:
                                            "Importance Level 1 agreement made by " +
                                            user.FirstName +
                                            " " +
                                            user.LastName +
                                            " on " +
                                            today.toUTCString(),
                                        attachments: null,
                                    });

                                    let newState = { ...newJobState };
                                    newState.Notes = notes;
                                    newState.SiteParameters.ImportanceLevel = 1;
                                    setNewJobState(newState);
                                }}
                                button2Text="Decline"
                                button2Click={() => setOpenImportanceLevel1Dialog(false)}
                            >
                                <div style={{ display: "flex" }}>
                                    <div>
                                        You have selected importance Level 1, this only applies for a freestanding
                                        structure that is greater than 1m from any existing structure.
                                        <br />
                                        <br />
                                        By clicking 'I Agree' you confirm that this meets the criteria for Importance
                                        level 1 and indemnify {brand} against all liability for the decision to
                                        continue. If you have any doubts, select ‘Decline’ and seek the advice of a
                                        suitably qualified professional prior to continuing.
                                    </div>
                                </div>
                            </BSL_Dialog>

                            <BSL_TextInput
                                label="Site/Delivery Notes"
                                multiline
                                value={newJobState?.SiteParameters?.DeliveryNotes}
                                rows={2}
                                style={{
                                    flex: 1,
                                }}
                                onBlur={(val) => {
                                    handleStateUpdate("SiteParameters", "DeliveryNotes", null, val);
                                }}
                            />
                        </div>
                    </div>

                    <div className={classes.divider} />

                    {newMode && (
                        <div className={classes.sectionContainer}>
                            <div className={sectionHeaderString}>Design</div>
                            <div className={classes.sectionContent}>
                                <div className={classes.sectionSubSection}>
                                    {window.FIELDERS && (
                                        <>
                                            <TemplateCard
                                                selected={design_selected === "Flat"}
                                                label={"Flat"}
                                                src={BaseURL("images/flat.png")}
                                                onClick={(label) => setDesign_selected(label)}
                                            />

                                            <TemplateCard
                                                selected={design_selected === "Gable"}
                                                label={"Gable"}
                                                src={BaseURL("images/gable.png")}
                                                onClick={(label) => setDesign_selected(label)}
                                            />
                                            <TemplateCard
                                                selected={design_selected === "Deck"}
                                                label={"Deck"}
                                                src={BaseURL("images/deck.png")}
                                                onClick={(label) => {
                                                    if (toNumber(user?.Role) >= 90) setDeckPageOpen(true);
                                                    setDesign_selected(label);
                                                }}
                                            />
                                        </>
                                    )}
                                </div>
                                {window.LYSAGHT && (
                                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                                        <TemplateCard
                                            selected={design_selected === "Skillion"}
                                            label={"Skillion"}
                                            src={BaseURL("images/lysaght-skillion.png")}
                                            onClick={(label) => setDesign_selected(label)}
                                        />
                                        <TemplateCard
                                            selected={design_selected === "Gable"}
                                            label={"Gable"}
                                            src={BaseURL("images/lysaght-gable.png")}
                                            onClick={(label) => setDesign_selected(label)}
                                        />
                                        <TemplateCard
                                            selected={design_selected === "National Carport"}
                                            label={"National Carport"}
                                            src={BaseURL("images/lysaght-carport.png")}
                                            onClick={(label) => setDesign_selected(label)}
                                            items={Object.keys(carportTemplates)}
                                            onClickSub={setSubTypeSelected}
                                            loading={windDataLoading}
                                            disabled={carportDisabled}
                                            disabledMessage={carportDisabledMessage}
                                            testId="carport-templates-template-card"
                                        />
                                        <TemplateCard
                                            selected={design_selected === "Deck"}
                                            label={"Deck"}
                                            src={BaseURL("images/lysaght-deck.png")}
                                            onClick={(label) => {
                                                setDeckPageOpen(true);
                                                setDesign_selected(label);
                                            }}
                                        />
                                        {window.LYSAGHT && toNumber(user?.Role) >= louvre_access_level && (
                                            <TemplateCard
                                                selected={design_selected === "Louvreroof"}
                                                label={"Louvreroof"}
                                                src={BaseURL("images/lysaght-carport.png")}
                                                onClick={(label) => setDesign_selected(label)}
                                                loading={windDataLoading}
                                                disabled={getLouvreDisabledMessage()}
                                                disabledMessage={getLouvreDisabledMessage()}
                                            />
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    <div className={classes.sectionContainer}>
                        <div className={sectionHeaderString}></div>
                        <div className={classes.sectionContent}>
                            <div
                                className={classes.sectionSubSection}
                                style={{
                                    flexDirection: "row",
                                    paddingTop: "28px",
                                    paddingLeft: "8px",
                                }}
                            >
                                {newMode && (
                                    <BSL_Button
                                        disabled={design_selected === "National Carport" && subTypeSelected === null}
                                        label="Create Job"
                                        onClick={validateAndCreate}
                                    />
                                )}
                                {editMode && (
                                    <React.Fragment>
                                        <BSL_Button
                                            className={classes.pulsingButton}
                                            disabled={props.job?.App?.Locked || !allowSave}
                                            label={
                                                !allowSave && windDataLoading ? "Awaiting Wind Data" : "Save Changes"
                                            }
                                            onClick={validateAndCreate}
                                        />
                                        {windDataLoading && <LinearProgress />}
                                    </React.Fragment>
                                )}
                                {duplicateMode && <BSL_Button label="Duplicate Job" onClick={validateAndCreate} />}
                                <BSL_Button
                                    label="Cancel"
                                    onClick={() => {
                                        editMode
                                            ? dispatch(toggleDesigner(SHOW_CUSTOMER_JOB_PANEL))
                                            : dispatch(changeMainPage("Recall"));
                                    }}
                                    style={{ marginLeft: "24px" }}
                                    secondary
                                />
                            </div>
                        </div>
                    </div>

                    {(toNumber(user?.Role) >= 90 || user.RoleName === "Super") && (
                        <>
                            <div className={classes.divider} />
                            <div
                                className={classes.sectionContainer}
                                style={{
                                    background: "aliceblue",
                                    maxWidth: "770px",
                                }}
                            >
                                <div className={sectionHeaderString}>Branch Options</div>
                                <div className={classes.sectionContent}>
                                    {toNumber(user?.Role) >= 90 && (
                                        <BSL_TextInput
                                            label="Transport / Splice Length"
                                            value={newJobState?.DesignParameters?.SplicingLength}
                                            rows={2}
                                            min={7000}
                                            max={99999}
                                            endAdornment="mm"
                                            style={{
                                                width: "160px",
                                                flex: 1,
                                            }}
                                            onBlur={(val) => {
                                                handleStateUpdate("DesignParameters", "SplicingLength", null, val);
                                            }}
                                        />
                                    )}
                                    {toNumber(user?.Role) >= 90 && (
                                        <BSL_CheckBox
                                            tight
                                            checked={newJobState?.DesignParameters?.AutoAddBeamBreakPost}
                                            returnInt
                                            label={
                                                <span style={{ whiteSpace: "nowrap" }}>
                                                    Auto Add Post to Beam Breaks
                                                </span>
                                            }
                                            onChange={(val) => {
                                                handleStateUpdate(
                                                    "DesignParameters",
                                                    "AutoAddBeamBreakPost",
                                                    null,
                                                    val
                                                );
                                            }}
                                            style={{
                                                marginTop: "-12px",
                                            }}
                                        />
                                    )}
                                    {toNumber(user?.Role) >= 99 && (
                                        <>
                                            <BSL_CheckBox
                                                tight
                                                checked={newJobState?.DesignParameters?.RemoveWatermarkOnDocuments}
                                                returnInt
                                                label={
                                                    <span style={{ whiteSpace: "nowrap" }}>
                                                        Remove Watermark on Documents{" "}
                                                        {newJobState?.DesignParameters?.RemoveWatermarkOnDocuments
                                                            ? "(Approved by " +
                                                              newJobState?.DesignParameters
                                                                  ?.RemoveWatermarkOnDocuments +
                                                              ")"
                                                            : ""}
                                                    </span>
                                                }
                                                onChange={(val) => {
                                                    handleStateUpdate(
                                                        "DesignParameters",
                                                        "RemoveWatermarkOnDocuments",
                                                        null,
                                                        val
                                                            ? app.user.DisplayName +
                                                                  " - " +
                                                                  new Date().toLocaleDateString()
                                                            : val
                                                    );
                                                }}
                                                style={{
                                                    marginTop: "-12px",
                                                }}
                                            />
                                            {newJobState?.DesignParameters?.RemoveWatermarkOnDocuments &&
                                                newJobState?.DesignParameters?.RemoveWatermarkOnDocuments.length >
                                                    1 && (
                                                    <BSL_TextInput
                                                        label="Reason for overriding watermark"
                                                        multiline
                                                        value={
                                                            newJobState?.DesignParameters
                                                                ?.RemoveWatermarkOnDocumentsReason
                                                        }
                                                        rows={2}
                                                        style={{
                                                            flex: 1,
                                                        }}
                                                        onBlur={(val) => {
                                                            handleStateUpdate(
                                                                "DesignParameters",
                                                                "RemoveWatermarkOnDocumentsReason",
                                                                null,
                                                                val
                                                            );
                                                        }}
                                                    />
                                                )}
                                        </>
                                    )}
                                    {toNumber(user?.Role) >= 99 && (
                                        <>
                                            <BSL_Button
                                                className={classes.pulsingButton}
                                                label="Customise Offering"
                                                onClick={() => {
                                                    setEditCustomOffering(true);
                                                    setValue(newJobState?.DesignParameters?.CustomisedOffering);
                                                    setJSONValid(
                                                        checkValidJSON(
                                                            newJobState?.DesignParameters?.CustomisedOffering
                                                        )
                                                    );
                                                }}
                                            />
                                            {editCustomOffering && (
                                                <BSL_Dialog
                                                    title={"Edit JSON for Customised Offering"}
                                                    open={true}
                                                    button1Text="SAVE"
                                                    button1Click={() => {
                                                        let valid = checkValidJSON(value);
                                                        setJSONValid(valid);
                                                        if (!valid && value !== "") {
                                                            alert(
                                                                "JSON is not valid. You cannot save this data. Fix it up and try again."
                                                            );
                                                        } else {
                                                            handleStateUpdate(
                                                                "DesignParameters",
                                                                "CustomisedOffering",
                                                                null,
                                                                value === ""
                                                                    ? ""
                                                                    : typeof value === "object"
                                                                    ? value
                                                                    : JSON.parse(value)
                                                            );
                                                            setEditCustomOffering(false);
                                                        }
                                                    }}
                                                    button2Text="Cancel"
                                                    button2Click={() => setEditCustomOffering(false)}
                                                    style={{ maxWidth: "initial", height: "95vh" }}
                                                    contentStyle={{ maxWidth: "initial", height: "95vh" }}
                                                    fullWidth={true}
                                                    maxWidth={"md"}
                                                >
                                                    <textarea
                                                        id="w3review"
                                                        name="w3review"
                                                        style={{
                                                            backgroundColor: "beige",
                                                            fontFamily: "monospace",
                                                            padding: "10px",
                                                            borderRadius: "9px",
                                                            color: "#444444",
                                                            overflowY: "auto",
                                                            fontSize: "12px",
                                                            width: "100%",
                                                            height: "90%",
                                                        }}
                                                        cols="75"
                                                        onChange={(e) => {
                                                            setValue(e.target.value);
                                                            setJSONValid(checkValidJSON(e.target.value));
                                                        }}
                                                        onBlur={(e) => {
                                                            let valid = checkValidJSON(e.target.value);
                                                            setJSONValid(valid);
                                                            if (valid) {
                                                                setValue(
                                                                    JSON.stringify(JSON.parse(e.target.value), null, 4)
                                                                );
                                                            }
                                                        }}
                                                        value={
                                                            value
                                                                ? typeof value === "object"
                                                                    ? JSON.stringify(value, null, 4)
                                                                    : value
                                                                : ""
                                                        }
                                                    />
                                                    <div
                                                        style={{
                                                            color: jsonValid ? "green" : "red",
                                                            fontSize: "12px",
                                                            padding: "10px",
                                                            textAlign: "center",
                                                        }}
                                                    >
                                                        {jsonValid ? "VALID JSON" : "NOT VALID JSON"}
                                                    </div>
                                                    <BSL_Button
                                                        className={classes.pulsingButton}
                                                        label="Load Basic Template"
                                                        onClick={() => {
                                                            setValue(
                                                                JSON.stringify(
                                                                    JSON.parse(
                                                                        '{"design_options": {"Flat Roof": {"length_range": {},"depth_range": {},"height_range": {}}}}'
                                                                    ),
                                                                    null,
                                                                    4
                                                                )
                                                            );
                                                            setJSONValid(true);
                                                        }}
                                                    />{" "}
                                                    &nbsp;
                                                    <BSL_Button
                                                        className={classes.pulsingButton}
                                                        disabled={!jsonValid}
                                                        label="Format"
                                                        onClick={() => {
                                                            let valid = checkValidJSON(value);
                                                            if (valid) {
                                                                setValue(JSON.stringify(JSON.parse(value), null, 4));
                                                            }
                                                        }}
                                                    />
                                                </BSL_Dialog>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                        </>
                    )}
                    {!editMode && (
                        <Message
                            open={showMessage}
                            message={showMessage?.message}
                            type={showMessage?.type}
                            onClose={() => setShowMessage(null)}
                        />
                    )}

                    {showWindDetails && (
                        <BSL_Dialog
                            title="Wind Data Detailed"
                            open={showWindDetails}
                            onClose={() => setShowWindDetails(false)}
                            button1Text="Close"
                            button1Click={() => {
                                setShowWindDetails(false);
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    fontSize: "12px",
                                }}
                            >
                                <JsonView
                                    data={newJobState?.SiteParameters?.WindData?.WindZoneAS1170}
                                    shouldInitiallyExpand={(level) => {
                                        if (level <= 1) return true;
                                        else return false;
                                    }}
                                    style={darkStyles}
                                />
                            </div>
                        </BSL_Dialog>
                    )}
                </div>
            </div>
            <Modal
                open={deckPageOpen}
                onClose={() => updateDeckPageOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: "40%",
                        left: "50%",
                        maxWidth: "1000px",
                        transform: "translate(-50%, -30%)",
                        width: "100%",
                        bgcolor: "background.paper",
                        border: "2px solid #000",
                    }}
                >
                    <DecksPage
                        deckState={deckState}
                        updateDeckState={updateDeckState}
                        setDeckPageOpen={updateDeckPageOpen}
                    />
                </Box>
            </Modal>
        </div>
    );
}
